<template>
  <div class="provider-accreditation" v-if="provider.showLogo === true">
    {{$t('message.labelProviderInAssociationWith')}}
    <div class="nhs-logo">
      <img src="static/nhs-logo.svg" alt="">
    </div>
    <img :src="$store.state.provider.logo">
  </div>
</template>
<script>
  export default {
    name: 'provider',
    computed : {
      provider() {
        let self = this;
        return self.$store.state.provider;
      }
    }
  }
</script>
<style scoped>
  .provider-accreditation {
    padding: 16px;
  }

  .provider-accreditation img {
    width: 156px;
  }

  .provider-accreditation .nhs-logo {
    margin-top: 8px;
    opacity: .8;
    transition: .2s ease-in-out;
  }

  .provider-accreditation .nhs-logo img {
    width: 75px;
  }

  .provider-accreditation .nhs-logo:hover {
    opacity: 1;
  }

  @media(max-height: 1200px) {
    .provider-accreditation {
      position: relative !important;
    }
  }

  @media (min-width: 1000px) {
    .provider-accreditation {
      position: absolute;
      bottom: 0;
      left: 0
    }
  }
</style>



// WEBPACK FOOTER //
// Provider.vue?7119ea3c